import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700" }
const _hoisted_2 = {
  key: 0,
  class: "mt-1 text-amber-700"
}
const _hoisted_3 = { class: "mt-1 text-gray-500" }

import { computed } from 'vue'

import { formatDateTime, PARSLEY_PATH } from '@/helpers/parsley'

const INCOMPLETE_NOTE =
  'Parsley marks this nutrition as incomplete. One or more ingredients have no nutrition in Parsley.'


export default {
  __name: 'ParsleyLockNotice',
  props: {
  link: { type: Object, required: true }
},
  setup(__props) {

const props = __props

const syncedText = computed(() =>
  props.link.synced_at ? `Last synced ${formatDateTime(props.link.synced_at)}.` : 'Waiting for the first sync.'
)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-medium text-gray-900" }, "Synced from Parsley:", -1)),
      _createTextVNode(" " + _toDisplayString(props.link.parsley_name) + ". " + _toDisplayString(syncedText.value), 1)
    ]),
    (props.link.nutrition_incomplete)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(INCOMPLETE_NOTE)))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_3, [
      _cache[2] || (_cache[2] = _createTextVNode(" Nutrition, ingredients and Contains labels are managed in Parsley. ", -1)),
      _createVNode(_component_router_link, {
        to: _unref(PARSLEY_PATH),
        class: "font-medium text-brand-600 hover:text-brand-700"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Change or remove the link ", -1)
        ]))]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

}